import { render, staticRenderFns } from "./GerarMdfeDetalhes.vue?vue&type=template&id=3945d8c1"
import script from "./GerarMdfeDetalhes.vue?vue&type=script&lang=js"
export * from "./GerarMdfeDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports